import { RUN_TRIGGER_TYPES } from "constants/run";

type FlowsTrigger = {
  projectId: string;
  flowId?: string;
  blockId?: string;
};

const TRIGGER_SEGMENTS: Record<string, keyof FlowsTrigger> = {
  project: "projectId",
  flow: "flowId",
  block: "blockId",
};

export const isFlowsTrigger = (triggeredBy?: string) =>
  !!triggeredBy?.startsWith(RUN_TRIGGER_TYPES.FLOWS_PREFIX);

/**
 * Flows authenticates per project and appends the originating flow, block and event
 * when it knows them, so only the project is guaranteed to be present:
 * `flows::project/<uuid>[/flow/<uuid>[/block/<uuid>[/event/<uuid>]]]`
 */
export const parseFlowsTrigger = (triggeredBy?: string): FlowsTrigger | undefined => {
  if (!triggeredBy || !isFlowsTrigger(triggeredBy)) {
    return undefined;
  }

  const segments = triggeredBy.slice(RUN_TRIGGER_TYPES.FLOWS_PREFIX.length).split("/");
  const parsed: Partial<FlowsTrigger> = {};

  for (let index = 0; index < segments.length; index += 2) {
    const key = TRIGGER_SEGMENTS[segments[index]];
    const value = segments[index + 1];

    if (key && value) {
      parsed[key] = value;
    }
  }

  const { projectId, ...rest } = parsed;

  if (!projectId) {
    return undefined;
  }

  return { projectId, ...rest };
};

export const getFlowsTriggerUrl = (baseUrl: string, trigger: FlowsTrigger) => {
  const instanceUrl = baseUrl.replace(/\/+$/, "");
  const { projectId, flowId, blockId } = trigger;

  if (!flowId) {
    return `${instanceUrl}/project/${projectId}`;
  }

  if (!blockId) {
    return `${instanceUrl}/flow/${flowId}`;
  }

  const selected = new URLSearchParams({ selected: JSON.stringify([blockId]) });

  return `${instanceUrl}/flow/${flowId}?${selected}`;
};
